const ManagementStructures = Object.freeze({
  MANAGER: "1",
  MEMBER: "2",
});

export default ManagementStructures;
